var map = {
	"./af.json": 96755,
	"./am.json": 18752,
	"./ar.json": 41928,
	"./az.json": 42949,
	"./be.json": 54741,
	"./bg.json": 13787,
	"./bn.json": 11810,
	"./bs.json": 10043,
	"./ca.json": 98542,
	"./cs.json": 37928,
	"./cy.json": 80873,
	"./da.json": 87930,
	"./de.json": 56277,
	"./dv.json": 67784,
	"./el.json": 15449,
	"./en.json": 31584,
	"./es.json": 22759,
	"./et.json": 55949,
	"./eu.json": 37379,
	"./fa.json": 62470,
	"./fi.json": 32275,
	"./fr.json": 3342,
	"./gl.json": 78629,
	"./ha.json": 78403,
	"./he.json": 29823,
	"./hi.json": 47755,
	"./hr.json": 72280,
	"./hu.json": 22817,
	"./hy.json": 14606,
	"./id.json": 41497,
	"./is.json": 6504,
	"./it.json": 93431,
	"./ja.json": 30444,
	"./ka.json": 13331,
	"./kk.json": 70031,
	"./km.json": 4045,
	"./ko.json": 59659,
	"./ku.json": 88142,
	"./ky.json": 25526,
	"./lt.json": 9,
	"./lv.json": 55071,
	"./mk.json": 74159,
	"./ml.json": 33456,
	"./mn.json": 18556,
	"./ms.json": 31513,
	"./nb.json": 33514,
	"./nl.json": 19863,
	"./nn.json": 92412,
	"./no.json": 68734,
	"./pl.json": 79496,
	"./ps.json": 44089,
	"./pt.json": 64226,
	"./ro.json": 3314,
	"./ru.json": 28967,
	"./sd.json": 73949,
	"./sk.json": 64193,
	"./sl.json": 86126,
	"./so.json": 16826,
	"./sq.json": 29700,
	"./sr.json": 52462,
	"./sv.json": 22909,
	"./sw.json": 42984,
	"./ta.json": 9699,
	"./tg.json": 41170,
	"./th.json": 90364,
	"./tr.json": 42159,
	"./tt.json": 80777,
	"./ug.json": 78103,
	"./uk.json": 81113,
	"./ur.json": 48119,
	"./uz.json": 74493,
	"./vi.json": 19301,
	"./zh.json": 42767
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8533;